
import { computed, defineComponent } from "vue";
import AccountBase from "@/views/crafted/account/Account-Base.vue";
import { useStore } from "vuex";

export default defineComponent({
  name: "Account-Overview",
  components: {
    AccountBase,
  },
  setup() {
    const store = useStore();
    const user = computed(() => store.getters.currentUser);
    const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));

    return {
      user,
      currentLanguage
    };
  },
});
